import { render, staticRenderFns } from "./manual_main.vue?vue&type=template&id=6b318bc2&scoped=true&"
import script from "./manual_main.vue?vue&type=script&lang=js&"
export * from "./manual_main.vue?vue&type=script&lang=js&"
import style0 from "./manual_main.vue?vue&type=style&index=0&lang=css&"
import style1 from "./manual_main.vue?vue&type=style&index=1&id=6b318bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b318bc2",
  null
  
)

export default component.exports